import {
  VStack,
  Grid,
  Heading,
  Text,
  Animate
} from 'wss3-forge'
import { usePageTitle } from '../../hooks/usePageTitle'
import { useSecurity } from '../../hooks/useSecurity'
import { LoginHistoryCard } from '../../components/security/LoginHistoryCard'
import { TrustedDevicesCard } from '../../components/security/TrustedDevicesCard'

export function Activity() {
  usePageTitle('Activity')
  const {
    loginHistory,
    trustedDevices,
    loading,
    revokeTrustedDevice,
    revokeAllTrustedDevices,
    addCurrentDeviceAsTrusted,
    getCurrentDeviceInfo
  } = useSecurity()

  const currentDeviceInfo = getCurrentDeviceInfo()

  return (
    <div className="page-content">
      <VStack gap="md">
        <Animate type="fadeIn">
          <VStack gap="xs">
            <Heading level={2}>Activity</Heading>
            <Text color="muted">View your login history and manage trusted devices</Text>
          </VStack>
        </Animate>

        <Animate type="slideInUp" delay={50}>
          <Grid columns={{ xs: 1, lg: 2 }} gap="md">
            <LoginHistoryCard
              history={loginHistory}
              loading={loading}
            />
            <TrustedDevicesCard
              devices={trustedDevices}
              loading={loading}
              onRevoke={revokeTrustedDevice}
              onRevokeAll={revokeAllTrustedDevices}
              onAddCurrentDevice={addCurrentDeviceAsTrusted}
              currentDeviceInfo={currentDeviceInfo}
            />
          </Grid>
        </Animate>
      </VStack>
    </div>
  )
}
